import { Phone, Mail, MapPin, FileText } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SITE } from "@/data/site";

const rowCls = "flex items-center gap-4 border-b border-white/10 py-5";
const labelCls = "font-mono-tl text-[11px] uppercase tracking-[0.25em] text-white/50";

const ROWS = [
    { id: "phone-link", icon: Phone, label: "Telefono", value: SITE.phoneDisplay, href: SITE.phoneHref, strong: true },
    { id: "email-link", icon: Mail, label: "Email", value: SITE.email, href: SITE.emailHref, strong: true },
    { id: "address", icon: MapPin, label: "Sede", value: SITE.address, href: SITE.mapsLink, external: true },
    { id: "vat", icon: FileText, label: "Dati fiscali", value: SITE.vat },
];

const ContactRow = ({ id, icon: Icon, label, value, href, strong, external }) => {
    const valueCls = strong
        ? "ml-auto break-all text-right font-display text-base font-semibold text-white group-hover:text-tl-orange"
        : `ml-auto text-right text-sm text-white/85 ${href ? "group-hover:text-tl-orange" : ""}`;
    const inner = (
        <>
            <Icon size={18} className="shrink-0 text-tl-orange" />
            <span className={labelCls}>{label}</span>
            <span className={valueCls}>{value}</span>
        </>
    );
    if (!href) {
        return <div data-testid={`contact-${id}`} className={rowCls}>{inner}</div>;
    }
    return (
        <a
            data-testid={`contact-${id}`}
            href={href}
            {...(external && { target: "_blank", rel: "noopener noreferrer" })}
            className={`group ${rowCls} transition-colors hover:bg-white/5`}
        >
            {inner}
        </a>
    );
};

export const ContactInfo = () => (
    <>
        <Reveal delay={0.12}>
            <p className="font-display text-xl font-bold text-white">{SITE.name}</p>
            <p className="mt-1 text-sm text-tl-mutedLight">
                {SITE.tagline} — {SITE.city}
            </p>
        </Reveal>
        <div className="mt-8 space-y-1 border-t border-white/10">
            {ROWS.map((row, i) => (
                <Reveal key={row.id} delay={0.16 + 0.04 * i}>
                    <ContactRow {...row} />
                </Reveal>
            ))}
        </div>
    </>
);
